import { Typography } from "@mui/material"
import type { BiomeshUnitResponse } from "@phc/common/gen/threatAnalyticsGen"
import {
  getListUnitsBiomeshUnitListGetQueryKey,
  useDeleteUnitBiomeshUnitUnitIdDelete,
} from "@phc/common/gen/threatAnalyticsGen"
import { useQueryClient } from "@tanstack/react-query"
import { enqueueSnackbar } from "notistack"
import type { FC } from "react"
import { useCallback } from "react"
import { Modal } from "../Shared/Modal"
import { extractApiError } from "./copUtils"

interface DeleteUnitDialogProps {
  open: boolean
  onClose: () => void
  unit: BiomeshUnitResponse
}

export const DeleteUnitDialog: FC<DeleteUnitDialogProps> = ({
  open,
  onClose,
  unit,
}) => {
  const queryClient = useQueryClient()
  const { mutateAsync: deleteUnit, isPending } =
    useDeleteUnitBiomeshUnitUnitIdDelete()

  const handleConfirm = useCallback(async () => {
    try {
      await deleteUnit({ unitId: unit.unit_id })
      await queryClient.invalidateQueries({
        queryKey: getListUnitsBiomeshUnitListGetQueryKey(),
      })
      enqueueSnackbar("Unit deleted", { variant: "success" })
      onClose()
    } catch (err) {
      enqueueSnackbar(extractApiError(err, "Failed to delete unit"), {
        variant: "error",
      })
    }
  }, [deleteUnit, unit.unit_id, queryClient, onClose])

  return (
    <Modal
      open={open}
      onClose={onClose}
      onConfirm={() => void handleConfirm()}
      title="Delete Unit"
      confirmLabel="Delete"
      disableBtns={isPending}
    >
      <Typography sx={{ mt: 1 }}>
        Are you sure you want to delete <strong>{unit.name}</strong>?
      </Typography>
    </Modal>
  )
}
